import { useEffect, useState } from "react";
import { _getUserGroups, _getUser, _saveUserDisplayName } from "../data/users";
import UserSettingsChangeName from "./partial/UserSettingsChangeName";
import LoadingModal from "./partial/LoadingModal";
import ViewMyGroups from "./partial/ViewMyGroups";
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../utils/firebase'; 
import RequestMyData from "./partial/RequestMyData";
import DeleteMyData from "./partial/DeleteMyData";

function ManageAccount() {

    const [isLoading, setIsLoading] = useState(true);
    const [userLoading, setUserLoading] = useState(true);
    const [groupsLoading, setGroupsLoading] = useState(true)

    useEffect(() => {
        if (!userLoading && !groupsLoading) {
            setIsLoading(false);
        }
    }, [userLoading, groupsLoading])

    useEffect(() => {
        // onAuthStateChanged returns an unsubscribe function
        const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
            if (auth) {
                setIsLoading(false);
            }
        });

        // Clean up the listener when the component unmounts
        return () => unsubscribe();
    }, []);


    if (isLoading) {
        return (<></>);
    }

    return (
        <>
            <LoadingModal />

            <div className="container indent-from-top ml-2 mr-2">

                <header className="has-text-centered mb-4">
                    <p className="subtitle">Account Management</p>
                </header>

                <UserSettingsChangeName setUserLoading={setUserLoading} />

                <ViewMyGroups setGroupsLoading={setGroupsLoading} />

                <RequestMyData />

                <DeleteMyData />

            </div>
        </>
    )
}

export default ManageAccount; 